module.exports = __webpack_public_path__ + "img/notifications-with-alert-white.72cebcf0.svg";